import { graphql } from '@generated/gql';

export const FETCH_PAGE_CONFIGURATION_NAME = graphql(/** GraphQL */ `
  query pageConfigurationBreadcrumbFetchPageConfigurationName(
    $pageConfigurationId: ObjectID!
  ) {
    fetchPageConfiguration(pageConfigurationId: $pageConfigurationId) {
      pageConfiguration {
        name
      }
    }
  }
`);
